import React from 'react';
import { ResourceTypeConfigItem } from 'components/cloudResources/cloudResourceTypesConfig';
import AWS_EC2_INSTANCES from './query';
import { ResourceColumn, TagList } from 'components/cloudResources';
import IssueCountBadge from 'components/issue/IssueCountBadge';
import { AWSEC2InstanceDetailTable } from './components';
import RegionLink from '../../components/RegionLink';
import CloudAccountLink from '../../components/CloudAccountLink';

const awsEc2Instances: ResourceTypeConfigItem = {
  key: 'AWS::EC2::Instance', // used for routing
  label: 'EC2 Instances',
  labelPlural: 'EC2 Instances',
  labelSingular: 'EC2 Instance',

  tableQuery: () => AWS_EC2_INSTANCES, // resources table.
  tableQueryVariables: () => ({}),

  // used in detail view
  detailTable: AWSEC2InstanceDetailTable,

  // used for inventoyr/resources list table
  tableColumnsConfig: [
    {
      title: 'Resource',
      key: 'resource',
      render: (_, item) => <ResourceColumn resource={item} />
    },
    {
      title: 'Account',
      key: 'account',
      dataIndex: 'account',
      className: 'no-wrap',
      render: account => <CloudAccountLink account={account} />
    },
    {
      title: 'Instance Type',
      dataIndex: 'instance_type',
      key: 'instance_type',
      className: 'no-wrap'
    },
    {
      title: 'Regions',
      dataIndex: 'dops_region',
      key: 'dops_region',
      className: 'no-wrap',
      render: region => <RegionLink region={region} />
    },
    {
      title: 'Issues',
      dataIndex: 'dops_issue_summary.open_count',
      key: 'issue_summary_open',
      align: 'center' as 'right',
      className: 'no-wrap text-center',
      render: issueCount => <IssueCountBadge issueCount={issueCount} />
    },
    {
      title: 'Tags',
      dataIndex: 'tags',
      key: 'tags',
      className: 'tags-col',
      width: '33%',
      render: tags => <TagList tags={tags} />
    }
  ]
};

export default awsEc2Instances;
